import { computed, unref, type Ref } from 'vue'
import type { EmojiSelectSize } from '../model/emoji-select-size'

export default function useUiConfigPreset(size: EmojiSelectSize | Ref<EmojiSelectSize>) {
  return computed(() => {
    const sizeVal = unref(size)

    if (sizeVal === 'medium') {
      return {
        emojiSize: 30,
        gridColumnCount: 6,
        gridRowCount: 5,
        gridGap: 10,
        headerRowSize: 20,
      }
    }

    if (sizeVal === 'large') {
      return {
        emojiSize: 30,
        gridColumnCount: 9,
        gridRowCount: 7,
        gridGap: 10,
        headerRowSize: 20,
      }
    }

    return {
      emojiSize: 30,
      gridColumnCount: 6,
      gridRowCount: 5,
      gridGap: 10,
      headerRowSize: 20,
    }
  })
}
